<button
    class="btn block"
    [ngClass]="buttonStyle"
    [classList]="classList"
    [attr.aria-label]="ariaLabel"
    [attr.id]="id"
    [attr.type]="type"
    [attr.tabindex]="tabindex"
    [disabled]="disabled"
    (click)="onClick($event)">
    <div class="grow min-h-6 flex items-center gap-2">
        <ng-content />
    </div>
</button>
